import axios from "axios";
import qs from "qs";
import { arrayBufferToBase64 } from "../../../utils/bufferToBase64";
import { take } from "../utils/constants";

export async function getTomPicturesRequest(params) {
    return axios.get(`${process.env.API_URL}/tom-cam-pictures`, {
        params,
        paramsSerializer: params => {
            return qs.stringify({ ...params })
        }
    }).then((response) => ({
        data: response.data.map((i) => ({
            ...i,
            file: arrayBufferToBase64(i.file?.Body?.data),
        })),
        nextSkip: response.data?.length < take ? 0 : params.skip + take,
    }))
}

export const getNotProcessedPicturesRequest = (params) => getTomPicturesRequest({ is_evaluation_required: 1, ...params })


export const makeReportRequest = ({ id, body }) => {
    return axios.post(`${process.env.API_URL}/tom-cam-pictures/make-report/${id}`, body)
}